import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonService } from 'src/app/services/common/common.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-restart-exam',
  templateUrl: './restart-exam.component.html',
  styleUrls: ['./restart-exam.component.scss']
})
export class RestartExamComponent {
  id: any = 0;
  studentName: any = '';
  studentId : number = 0;
  examId : number = 0;

  constructor(
    public modalService: NgbActiveModal,
    private apiUrl: ApiUrlHelper,
    public commonService: CommonService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
  }

  Restart(i: any) {
    this.spinner.show();
    var flag = false;
    if (i == 1) {
      flag = true
    }
    const objData = {
      examSubmitId: this.id,
      IsFromStart: flag,
      studentId:this.studentId,
      examId:this.examId
    }
    const ApiURL = this.apiUrl.apiUrl.test.RestartTest;
    this.commonService.doPost(ApiURL, objData).pipe().subscribe({
      next: (data) => {
        if (data.success) {
          this.spinner.hide();
          this.toastr.success(data.message);
          this.modalService.close();
          window.location.reload();
        }
        else {
          this.spinner.hide();
          this.toastr.error(data.message);
        }
      },
      error: (er) => {
        console.error(er)
      }
    });
  }
}